import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./DatePickerCustomStyle.css";
import AddMemebersNotice from "./AddMembersNotice";

const timeHelper = (a) => {
  const inputDateString = a;
  const dateObj = new Date(inputDateString);
  const day = dateObj.getUTCDate();
  const month = dateObj.getUTCMonth() + 1;
  const year = dateObj.getUTCFullYear();
  const outputDateString = `${year}-${month}-${day}`;
  return outputDateString;
};

const Create_Notice = ({
  setCreateNotice,
  createNotice,
  onSucess1,
  refetch,
}) => {
  const [write_something, setWrite_Something] = useState("");
  const [attach_link, setAttach_Link] = useState("");
  const [deadline, setDeadline] = useState(null);
  const [datedisplay, setDateDisplay] = useState(null);
  const [addMemberClick, setAddMemberClick] = useState(false);
  const [studentIds, setStudentIds] = useState([]);
  const [teacherIds, setTeacherIds] = useState([]);
  const [teracherIdtoDisplay, setTeacherIdtoDisplay] = useState([]);
  const [isPublish, setIsPublish] = useState(true);
  const [noticeError, setNoticeError] = useState("Something Went Wrong!");
  const [error, setError] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [
    selectedStudentListClassStateParent,
    setSelectedListStudentClassStateParent,
  ] = useState([]);
  const [stdParent, setStdParent] = useState([]);
  const [secParent, setSecParent] = useState([]);
  console.log(datedisplay?.toDateString());
  const handle_attachLink = (event) => {
    setAttach_Link(event.target.value);
  };
  const handle_deadline = (event) => {
    let res = timeHelper(event);
    setDeadline(res);
    setIsCalendarOpen(false);
  };
  const studentLists = (para) => {
    const valuesArray = para?.map((obj) => obj.value);
    setStudentIds(valuesArray);
  };
  const teacherLists = (para) => {
    const valuesArr = para?.map((obj) => obj.value);
    setTeacherIds(valuesArr);
    setTeacherIdtoDisplay(valuesArr)
  };
  const handle_createNotice = async () => {
    let Teacher_Id = JSON.parse(localStorage.getItem("Teacher_id"));

    setTeacherIds((prevTeacherIds) => {
      // Check if the Teacher_Id is already in the array
      if (prevTeacherIds.includes(Teacher_Id)) {
        // If it's already present, return the previous array unchanged
        return prevTeacherIds;
      }
      // If it's not present, add the new Teacher_Id to the array
      return [...prevTeacherIds, Teacher_Id];
    });

    try {
      let new_res = {
        teacher_id: Teacher_Id,
        notice: write_something,
        embedded_link: attach_link,
        deadline: deadline,
        students: studentIds,
        teachers: teacherIds.length > 0 ? teacherIds : [Teacher_Id],
      };
      await axios
        .post("/api/v1/noticeBoard/notice/create", new_res)
        .then((res) => {
          if (res.data.status === true) {
            setCreateNotice((prev) => !prev);
            // window.location.reload()
            refetch();
            onSucess1();
            localStorage.removeItem("TEACHER_OPTIONS_STORAGE_KEY");
            localStorage.removeItem("STUDENT_OPTIONS_STORAGE_KEY");
          }
        })
        .catch((error) => {
          setError(true);
          setNoticeError(error.response.data.message);
          console.log("err");
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (write_something.trim() && deadline) {
      if (studentIds.length > 0 || teacherIds.length > 0) {
        setIsPublish(false);
      }
    } else {
      setIsPublish(true);
    }
  }, [write_something, deadline, studentIds, teacherIds]);
  const handle_writeSomething = (event) => {
    const value = event.target.value;
    const regex = /^[a-zA-Z0-9 ,.'/-]*$/;
    if (regex.test(value) || value === "") {
      setWrite_Something(value);
    }
  };
  return (
    <>
      <div className=" d-flex create_channel_transprant_body_notice ">
        {!addMemberClick ? (
          <div
            className="create_channel_container_notice"
            style={{ overflow: error && "scroll" }}
          >
            <div className="create_noticd_notice col-md-5 ">
              Create New Notice
            </div>
            {error && <p style={{ fontSize: "small", color: "red" }}>{noticeError}</p>}
            <div className="Write_something_dcm">
              <textarea
                id="write_something_id"
                value={write_something}
                className="write_something"
                placeholder="Write Your Notice"
                onChange={handle_writeSomething}
                maxLength={250}
              ></textarea>
            </div>
            <div className="Write_something_dcmA">
              <textarea
                id="write_something_id1"
                className="write_something1"
                value={attach_link}
                placeholder="Add embedded link"
                onChange={handle_attachLink}
              ></textarea>
            </div>
            <div
              className="Write_something_dcmA d-flex justify-content-between"
              onClick={() => setIsCalendarOpen(true)}
            >
              <DatePicker
                selected={datedisplay}
                placeholderText={
                  datedisplay
                    ? datedisplay.toLocaleDateString("en-GB") // Display in DD/MM/YYYY format
                    : "Pick an expiry Date"
                }
                dateFormat="dd/MM/yyyy"
                className="DatePickerStyle w-100"
                onChange={(date) => {
                  handle_deadline(date);
                  setDateDisplay(date);
                }}
                minDate={new Date()} // Ensure user can only select today or future dates
                open={isCalendarOpen}
                onClickOutside={() => setIsCalendarOpen(false)}
              />
              <div
                className="mr-3"
              // onClick={() => setIsCalendarOpen(!isCalendarOpen)}
              >
                <img src="images/calImg.svg" alt="" />
              </div>
            </div>
            <div className="button-row mt-3">
              <div className="AddMemberButton">
                {studentIds.length + teacherIds.length > 0 ? (
                  <button
                    className="Add_Member"
                    onClick={() => {
                      setAddMemberClick(true);
                    }}
                  >
                    Edit members
                  </button>
                ) : (
                  <button
                    className="Add_Member"
                    onClick={() => {
                      setAddMemberClick(true);
                    }}
                  >
                    Add members
                  </button>
                )}
                {(studentIds.length > 0 || teacherIds.length > 0) && (
                  <p className="Member_LengthPara mt-4">
                    {studentIds.length + teracherIdtoDisplay.length} members added
                  </p>
                )}
              </div>
              <button
                className={
                  !isPublish
                    ? "PublishBtn_notice_DcmA"
                    : "PublishBtn_notice_DcmADisable"
                }
                onClick={handle_createNotice}
                disabled={isPublish}
              >
                Publish
              </button>
            </div>
          </div>
        ) : (
          <div className="create_channel_container_notice1 ">
            <AddMemebersNotice
              setAddMemberClick={setAddMemberClick}
              addMemberClick={addMemberClick}
              studentLists1={studentLists}
              teacherLists1={teacherLists}
              selectedStudentListClassStateParent={
                selectedStudentListClassStateParent
              }
              setSelectedListStudentClassStateParent={
                setSelectedListStudentClassStateParent
              }
              stdParent={stdParent}
              setStdParent={setStdParent}
              secParent={secParent}
              setSecParent={setSecParent}
            />
          </div>
        )}
        <img
          src="/images/cross-circle3.svg"
          className={
            addMemberClick ? "create_channel_close_btn" : "notice_close_button"
          }
          onClick={(e) => {
            setCreateNotice(false);
            localStorage.removeItem("TEACHER_OPTIONS_STORAGE_KEY");
            localStorage.removeItem("STUDENT_OPTIONS_STORAGE_KEY");
          }}
          alt="cross circle"
        />
      </div>
    </>
  );
};

export default Create_Notice;
